document.addEventListener('DOMContentLoaded', () => {
  const skipLink = document.querySelector('.tco-skip-link');
  const body = document.body;

  skipLink.addEventListener('focus', function() {
    body.classList.add('tco-skip-link-has-focus');
  });

  skipLink.addEventListener('blur', function() {
    body.classList.remove('tco-skip-link-has-focus');
  });
})